import React, { Component } from 'react'
import { connect } from 'react-redux'
import RefundSample from '../samples/RefundSample'
import { makeRefund, setErrorMessage } from '../../../actions/transactionsActions'
import { _DOTNET, _JAVA, _PHP, REFUND_FAIL } from '../../../actions/types'

const CODES = {
    store_ID: ["mpgReq.SetStoreId(store_id);", "mpgReq.setStoreId(store_id);", "'store_id'=>$store_id"],
    API_token: ["mpgReq.SetApiToken(api_token);", "mpgReq.setApiToken(api_token);", "'api_token'=>$api_token"],
    status_check: ["mpgReq.SetStatusCheck(status_check);", "mpgReq.setStatusCheck(status_check);", "$mpgHttpPost = new mpgHttpsPostStatus\n($store_id,$api_token,$status,$mpgRequest);"],
    order_ID: ["refund.SetOrderId(order_id);", "refund.setOrderId(order_id);", "'order_id'=>$order_id"],
    amount: ["refund.SetAmount(amount);", "refund.setAmount(amount);", "'amount'=>$amount"],
    transaction_number: ["refund.SetTxnNumber(txn_number);", "refund.setTxnNumber(txn_number);", "'txn_number'=>$txn_number"],
    electronic_commerce_indicator: ["refund.SetCryptType(crypt);", "refund.setCryptType(crypt);", "'crypt_type'=>$crypt"],
}

export class Refund extends Component {
    onMakeRefundPress() {
        const { storeId, apiToken, orderId, txnNumber, amount, prevSuccStep, preAuthCompSuccess, purchaseSuccess, forcePostSuccess } = this.props;
        if(txnNumber !== 'none' && orderId !== 'none' && prevSuccStep === 9 && (preAuthCompSuccess || purchaseSuccess || forcePostSuccess)) {
            this.setState({ showErr: false });
            const refundRequest = { storeId, apiToken, orderId, txnNumber, amount };
            this.props.makeRefund(refundRequest);
        }
        else {
            this.props.setErrorMessage("This transaction has a pre-requisite transaction: Batch Close and any of (Purchase, Pre-Authorization Completion or Force Post).", REFUND_FAIL);
        }
    }

    renderIntegrationTool() {
        return (
            <div className="stepMainContainer">
                <h3>Sample Refund</h3>
                <RefundSample />
                <div className="requestButton" onClick={() => this.onMakeRefundPress()}>
                    Refund Request
                </div>
            </div>
        );
    }

    renderDocument() {
        const { progLangId } = this.props;

        return (
            <div className="stepPageContainer">
                <span className="stepPageTitle"><b>Refund</b></span>
                <p style={{marginTop: '3vh'}}>Restores all or part of the funds from a Purchase, Pre-Authorization Completion or Force Post transaction to the cardholder's card.</p>
                <p>Unlike a Purchase Correction, there is a record of both the initial charge and the refund on the cardholder's statement.</p>
                <p>For processing refunds on a different card than the one used in the original transaction, the Independent Refund transaction should be used instead.</p>
                <p>To process this transaction, you need the order ID and transaction number from the original Completion, Purchase or Force Post transaction.</p>

                <p><b>Refund transaction object definition</b></p>
                {(() => {
                switch(progLangId) {
                    case _DOTNET:
                        return <code>Refund refund = new Refund();</code>
                    case _JAVA:
                        return <code>Refund refund = new Refund();</code>
                    case _PHP:
                        return <code>$txnArray = array(‘type’=>’refund', …);<br />$mpgTxn = new mpgTransaction($txnArray);</code>
                    default:
                        return null
                    }
                })()}

                <p style={{ marginTop: '5vh'}}><b>HttpsPostRequest object for Refund transaction</b></p>
                {(() => {
                switch(progLangId) {
                    case _DOTNET:
                        return <code>HttpsPostRequest mpgReq = new HttpsPostRequest();<br />mpgReq.SetTransaction(refund);</code>
                    case _JAVA:
                        return <code>HttpsPostRequest mpgReq = new HttpsPostRequest();<br />mpgReq.setTransaction(refund);</code>
                    case _PHP:
                        return <code>$mpgRequest = new mpgRequest($mpgTxn);<br />$mpgHttpPost = new mpgHttpsPost($store_id,$api_token,$mpgRequest);</code>
                    default:
                        return null
                    }
                })()}

                <h3 style={{ marginTop: '7vh'}}>Core connection object fields (all API transactions)</h3>
                <table>
                    <th>Variable Name</th>
                    <th>Type and Limits</th>
                    <th>Set Method</th>

                    <tr>
                        <td>store ID</td>
                        <td><i>String</i><br /><br /> N/A</td>
                        <td><code>{CODES.store_ID[progLangId]}</code></td>
                    </tr>

                    <tr>
                        <td>API token</td>
                        <td><i>String</i><br /><br /> N/A</td>
                        <td><code>{CODES.API_token[progLangId]}</code></td>
                    </tr>
                </table>

                <h3 style={{ marginTop: '7vh'}}><b>Optional connection object field</b></h3>
                <table>
                    <th>Variable Name</th>
                    <th>Type and Limits</th>
                    <th>Set Method</th>

                    <tr>
                        <td>status check</td>
                        <td><i>Boolean</i><br /><br />true/false</td>
                        <td><code>{CODES.status_check[progLangId]}</code></td>
                    </tr>
                </table>

                <h3 style={{ marginTop: '7vh'}}>Refund transaction request fields – Required</h3>
                <table>
                    <th>Variable Name</th>
                    <th>Type and Limits</th>
                    <th>Set Method</th>

                    <tr>
                        <td>order ID</td>
                        <td><i>String</i><br /><br />50-character alphanumeric<br />a-Z A-Z 0-9 _ - : . @ spaces</td>
                        <td><code>{CODES.order_ID[progLangId]}</code></td>
                    </tr>
                    <tr>
                        <td>amount</td>
                        <td><i>String</i><br /><br />10-character decimal<br />Up to 7 digits (dollars) +<br />decimal point (.) + 2 digits<br />(cents) after the decimal<br />point</td>
                        <td><code>{CODES.amount[progLangId]}</code></td>
                    </tr>
                    <tr>
                        <td>transaction number</td>
                        <td><i>String</i><br /><br />255-character, alphanumeric, hyphens or underscores<br />variable length</td>
                        <td><code>{CODES.transaction_number[progLangId]}</code></td>
                    </tr>
                    <tr>
                        <td>electronic commerce indicator</td>
                        <td><i>String</i><br /><br />1-character alphanumeric</td>
                        <td><code>{CODES.electronic_commerce_indicator[progLangId]}</code></td>
                    </tr>
                </table>
            </div>
        )
    }

    render() {
        const { mode } = this.props;
        if(mode === 'interactive_tool')
            return this.renderIntegrationTool();
        else if(mode === 'integration_guide')
            return this.renderDocument();
        else {
            return null;
        }
    }
}

const mapStateToProps = state => {
    const { mode } = state.common.sideNav;
    const { storeId, apiToken, orderId, txnNumber, amount } = state.transactions.main.config;
    const { prevSuccStep, preAuthCompSuccess, purchaseSuccess, forcePostSuccess } = state.transactions.main;
    return { preAuthCompSuccess, purchaseSuccess, forcePostSuccess, prevSuccStep, mode, storeId, apiToken, orderId, txnNumber, amount, progLangId: state.common.progLangList.selection };
}

export default connect(mapStateToProps,{makeRefund, setErrorMessage})(Refund)
